<template>
  <div>
    <CurrentStockAdjustTemp goods-option="S0104" goods-type="다공정품"/>
  </div>

</template>

<script>
import CurrentStockAdjustTemp from './CurrentStockAdjustTemp'
export default {
  name: 'CurrentWipStockAdjust',
  data: function () {
    return {
    }
  },
  components: {
    CurrentStockAdjustTemp
  },
  created () {
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
  }
}
</script>

<style lang="scss">

</style>
